import { http } from 'http';

export default {
  updateCampaign: (campaignId, fieldsChangedSend) =>
    http.patch(`/webh/campaigns/${campaignId}`, fieldsChangedSend, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    })
};
